import * as React from "react";

// Stores
import { ActivityStore } from "stores";

// Layout
import { Grid } from "@material-ui/core";
import { Observer } from "mobx-react-lite";
import {
    CardTypeButtons,
    FontSizeButtons,
    worksheetOptionsBackgroundStyle,
} from "components/activities/CommonActivityOptions";
import { CardType } from "models/customLists/CategoryItem";
import { NumberOfWorksheetColumns } from "../WorksheetHelper";
import { WorksheetOptions } from "../WorksheetScene";
import SimpleCheckbox from "components/SimpleCheckbox";
import { strings } from "core/localizedStrings";

export interface RacetrackWorksheetOptions extends WorksheetOptions {
    cardType: CardType;
}

export const defaultRacetrackWorksheetOptions: RacetrackWorksheetOptions = {
    cardType: CardType.IMAGE_ONLY,
};

interface RacetrackWorksheetOptionsProps extends React.Props<any> {
    activityStore: ActivityStore;
}

const RacetrackWorksheetOptions = (props: RacetrackWorksheetOptionsProps) => {
    const handleCardTypeChanged = (cardType: CardType) => {
        props.activityStore.activityOptions.racetrackWorksheetOptions.cardType = cardType;
        props.activityStore.updateOptions();
    };

    return (
        <Observer
            render={() => (
                <>
                    <CardTypeButtons
                        activityStore={props.activityStore}
                        onCardTypeChanged={handleCardTypeChanged}
                        selectedType={props.activityStore.activityOptions.racetrackWorksheetOptions.cardType}
                    />
                </>
            )}
        />
    );
};

export default RacetrackWorksheetOptions;
